document.addEventListener("DOMContentLoaded", () => {

    initDiscountPercentages();

    initPackSelector();

    initAddToCart();

    initGridSwitcher();

    initSort()

    initFilterAccordion();

    initFilterSearch();

    initImageHover();

    initCardAnimation();

    initPriceFilter();

    initClearFilters();

    hideEmptyPacks();

    initBulkOrderPopup();

    initCollectionVideoModal();

});

function showLoader(title, text) {

    const loader = document.getElementById("hgpCartLoader");

    if (!loader) return;

    document.getElementById("hgpLoaderTitle").textContent = title;

    document.getElementById("hgpLoaderText").textContent = text;

    loader.classList.add("active");

    loader.setAttribute("aria-hidden", "false");

}

function hideLoader() {

    const loader = document.getElementById("hgpCartLoader");

    if (!loader) return;

    loader.classList.remove("active");

    loader.setAttribute("aria-hidden", "true");

}

function updateDiscountPercentage(card) {
    if (!card) return;

    const priceElement = card.querySelector(".current-price");
    const compareElement = card.querySelector(".compare-price");

    if (!priceElement || !compareElement) return;

    const currentPrice = parseFloat(
        priceElement.textContent.replace(/[^\d]/g, "")
    );

    const comparePrice = parseFloat(
        compareElement.textContent.replace(/[^\d]/g, "")
    );

    if (
        !Number.isFinite(currentPrice) ||
        !Number.isFinite(comparePrice) ||
        comparePrice <= currentPrice ||
        comparePrice <= 0
    ) {
        card.querySelector(".hgp-discount-percentage")?.remove();
        return;
    }

    const discount = Math.round(
        ((comparePrice - currentPrice) / comparePrice) * 100
    );

    let discountElement = card.querySelector(
        ".hgp-discount-percentage"
    );

    if (!discountElement) {
        discountElement = document.createElement("span");
        discountElement.className = "hgp-discount-percentage";

        const priceWrapper = card.querySelector(".hgp-price");

        if (priceWrapper) {
            priceWrapper.appendChild(discountElement);
        }
    }

    discountElement.textContent = `${discount}% OFF`;
}

function initDiscountPercentages() {
    document.querySelectorAll(".hgp-card").forEach((card) => {
        updateDiscountPercentage(card);
    });
}

function initPackSelector() {

    document.querySelectorAll(".hgp-pack-selector").forEach((selector) => {

        const packs = selector.querySelectorAll(".hgp-pack");

        const card = selector.closest(".hgp-card");

        updateDiscountPercentage(card);

        const addButton = card.querySelector(".hgp-add-cart");

        const price = card.querySelector(".current-price");

        const compare = card.querySelector(".compare-price");

        packs.forEach((pack) => {

            pack.addEventListener("click", () => {

                packs.forEach(p => p.classList.remove("active"));

                pack.classList.add("active");

                addButton.dataset.variant = pack.dataset.id;

                if (price) {

                    price.textContent = pack.dataset.price;

                }

                if (compare && pack.dataset.compare) {

                    compare.textContent = pack.dataset.compare;

                }

                updateDiscountPercentage(card);

            });

        });

    });

}

function initAddToCart() {

    const loader = document.getElementById("hgpCartLoader");

    document.querySelectorAll(".hgp-add-cart").forEach((button) => {

        button.addEventListener("click", async () => {

            if (button.classList.contains("loading")) return;

            button.classList.add("loading");

            if (loader) {

                showLoader(
                    "Adding Product",
                    "Adding product to your cart..."
                );

                loader.setAttribute("aria-hidden", "false");

            }

            try {

                const response = await fetch("/cart/add.js", {

                    method: "POST",

                    headers: {
                        "Content-Type": "application/json"
                    },

                    body: JSON.stringify({

                        id: button.dataset.variant,

                        quantity: 1

                    })

                });

                if (!response.ok) {

                    throw new Error("Add to cart failed");

                }

                const cart = await fetch("/cart.js");

                const cartData = await cart.json();

                const count = document.querySelector("[data-cart-count]");

                if (count) {

                    count.textContent = cartData.item_count;

                    count.classList.remove("is-empty");

                }

                const cartButton = document.querySelector(".hgp-cart-icon-btn");

                if (cartButton) {

                    // restart animation every click
                    cartButton.classList.remove("cart-celebrate");

                    void cartButton.offsetWidth;

                    cartButton.classList.add("cart-celebrate");

                    setTimeout(() => {

                        cartButton.classList.remove("cart-celebrate");

                    }, 3600);

                }

            }

            catch (err) {

                console.error(err);

                alert("Unable to add product to cart.");

            }

            finally {

                button.classList.remove("loading");

                if (loader) {

                    hideLoader();

                    loader.setAttribute("aria-hidden", "true");

                }

            }

        });

    });

}

function initSort() {

    const dropdown = document.querySelector(".hgp-sort-dropdown");

    if (!dropdown) return;

    const trigger = dropdown.querySelector(".hgp-sort-trigger");

    const options = dropdown.querySelectorAll("[data-sort]");

    trigger.addEventListener("click", (e) => {

        e.stopPropagation();

        dropdown.classList.toggle("active");

    });

    document.addEventListener("click", () => {

        dropdown.classList.remove("active");

    });

    options.forEach((option) => {

        option.addEventListener("click", () => {

            const url = new URL(window.location);

            if (option.dataset.sort) {

                url.searchParams.set("sort_by", option.dataset.sort);

            } else {

                url.searchParams.delete("sort_by");

            }

            window.location = url;

        });

    });

}

function initGridSwitcher() {

    const buttons = document.querySelectorAll("[data-grid]");

    const grid = document.querySelector(".hgp-grid");

    if (!buttons.length || !grid) return;

    buttons.forEach((btn) => {

        btn.addEventListener("click", () => {

            buttons.forEach(b => b.classList.remove("active"));

            btn.classList.add("active");

            grid.style.gridTemplateColumns = `repeat(${btn.dataset.grid},minmax(0,1fr))`;

        });

    });

}

function initFilterAccordion() {

    const blocks = document.querySelectorAll(".hgp-filter-block");

    blocks.forEach((block, index) => {

        const title = block.querySelector(".hgp-filter-title");
        const content = block.querySelector(".hgp-filter-content");

        if (!title || !content) return;

        // Close everything initially
        block.classList.remove("active");
        content.style.maxHeight = "0px";

        // Open first filter by default
        const hasActive = block.querySelector(".hgp-checkbox.active");

        if (hasActive) {

            block.classList.add("active");

            content.style.maxHeight = content.scrollHeight + "px";

        } else if (index === 0) {

            block.classList.add("active");

            content.style.maxHeight = content.scrollHeight + "px";

        }

        title.addEventListener("click", () => {

            const isOpen = block.classList.contains("active");

            // Close all filters
            blocks.forEach(item => {

                item.classList.remove("active");

                const body = item.querySelector(".hgp-filter-content");

                body.style.maxHeight = "0px";

            });

            // Re-open if it wasn't already open
            if (!isOpen) {

                block.classList.add("active");

                content.style.maxHeight = content.scrollHeight + "px";

            }

        });

    });

}

function initFilterSearch() {

    const input = document.getElementById("hgpFilterSearch");

    if (!input) return;

    input.addEventListener("keyup", () => {

        const value = input.value.toLowerCase();

        document.querySelectorAll(".hgp-filter-block").forEach((block) => {

            const text = block.querySelector(".hgp-filter-title").innerText.toLowerCase();

            block.style.display = text.includes(value) ? "" : "none";

        });

    });

}


function initImageHover() {

    document.querySelectorAll(".hgp-card").forEach((card) => {

        const images = card.querySelectorAll(".hgp-image-wrapper img");

        if (images.length <= 1) return;

        let index = 0;

        let interval;

        card.addEventListener("mouseenter", () => {

            interval = setInterval(() => {

                images.forEach(img => img.style.opacity = 0);

                index = (index + 1) % images.length;
                images[index].style.opacity = 1;

            }, 900);

        });

        card.addEventListener("mouseleave", () => {

            clearInterval(interval);

            images.forEach(img => img.style.opacity = 0);

            index = 0;

            images[0].style.opacity = 1;

        });

    });

}

function initCardAnimation() {

    const observer = new IntersectionObserver((entries) => {

        entries.forEach((entry) => {

            if (entry.isIntersecting) {

                entry.target.classList.add("show");

            }

        });

    }, {

        threshold: .15

    });

    document.querySelectorAll(".hgp-card").forEach((card) => {

        observer.observe(card);

    });

}

function initPriceFilter() {

    const apply = document.querySelector(".hgp-price-apply");

    const clear = document.querySelector(".hgp-price-clear");

    if (!apply) return;

    apply.addEventListener("click", () => {

        const min = document.getElementById("hgpMinPrice").value;

        const max = document.getElementById("hgpMaxPrice").value;

        const url = new URL(window.location);

        if (min) {

            url.searchParams.set("filter.v.price.gte", min);

        }

        if (max) {

            url.searchParams.set("filter.v.price.lte", max);

        }

        showLoader(

            "Filtering Products",

            "Finding matching products..."

        );



        window.location = url;

    });

    clear.addEventListener("click", () => {

        const url = new URL(window.location);

        url.searchParams.delete("filter.v.price.gte");

        url.searchParams.delete("filter.v.price.lte");

        showLoader(

            "Resetting Price",

            "Loading products..."

        );

        window.location = url;

    });

}


initInfiniteScroll();

function initInfiniteScroll() {

    const pagination = document.getElementById("hgpPagination");
    const loader = document.getElementById("hgpInfiniteLoader");

    if (!pagination) return;

    let loading = false;

    const observer = new IntersectionObserver(async (entries) => {

        if (!entries[0].isIntersecting || loading) return;

        const nextLink = pagination.querySelector("a.pagination__item--prev");

        if (!nextLink) {

            observer.disconnect();
            loader.style.display = "none";
            return;

        }

        loading = true;
        loader.classList.add("active");

        try {

            const response = await fetch(nextLink.href);

            const html = await response.text();

            const parser = new DOMParser();

            const doc = parser.parseFromString(html, "text/html");

            // ---------- PACK 1 ----------
            appendCards(
                "#pack1Grid",
                doc.querySelectorAll("#pack1Grid > .hgp-card")
            );

            // ---------- PACK 2 ----------
            appendCards(
                "#pack2Grid",
                doc.querySelectorAll("#pack2Grid > .hgp-card")
            );

            // ---------- PACK 3 ----------
            appendCards(
                "#pack3Grid",
                doc.querySelectorAll("#pack3Grid > .hgp-card")
            );

            // ---------- PACK 4 ----------
            appendCards(
                "#pack4Grid",
                doc.querySelectorAll("#pack4Grid > .hgp-card")
            );

            hideEmptyPacks();

            // Replace pagination
            const newPagination = doc.getElementById("hgpPagination");

            if (newPagination) {

                pagination.innerHTML = newPagination.innerHTML;

            } else {

                pagination.remove();

                observer.disconnect();

            }

            // Reinitialize JS
            initDiscountPercentages();
            initPackSelector();
            initAddToCart();
            initImageHover();
            initCardAnimation();

        }

        catch (err) {

            console.error(err);

        }

        finally {

            loading = false;

            loader.classList.remove("active");

        }

    }, {
        rootMargin: "400px"
    });

    observer.observe(loader);

}



function appendCards(targetSelector, cards) {

    const target = document.querySelector(targetSelector);

    if (!target) return;

    cards.forEach(card => {

        target.appendChild(card);

    });

}

function hideEmptyPacks() {

    document.querySelectorAll(".hgp-pack-section").forEach(section => {

        const cards = section.querySelectorAll(".hgp-card");

        if (cards.length === 0) {

            section.style.display = "none";

        } else {

            section.style.display = "block";

        }

    });

}

function initClearFilters() {

    const button = document.querySelector(".hgp-clear-filters");

    if (!button) return;

    button.addEventListener("click", () => {

        showLoader(

            "Resetting Filters",

            "Loading all products..."

        );

        setTimeout(() => {

            window.location = window.location.pathname;

        }, 400);

    });

}





const mobileFilter = document.querySelector(".hgp-mobile-filter");
const overlay = document.querySelector(".hgp-mobile-overlay");
const filterBtn = document.querySelector(".hgp-mobile-filter-btn");
const closeBtn = document.querySelector(".hgp-filter-close");

function openFilter() {

    mobileFilter.classList.add("active");

    overlay.classList.add("active");

    document.body.classList.add("hgp-lock-scroll");

}

function closeFilter() {

    mobileFilter.classList.remove("active");

    overlay.classList.remove("active");

    document.body.classList.remove("hgp-lock-scroll");

}

filterBtn?.addEventListener("click", openFilter);

closeBtn?.addEventListener("click", closeFilter);

overlay?.addEventListener("click", closeFilter);




const sortSheet = document.querySelector(".hgp-sort-sheet");

const sortBtn = document.querySelector(".hgp-mobile-sort-btn");

const sortClose = document.querySelector(".hgp-sort-close");

sortBtn?.addEventListener("click", () => {

    sortSheet.classList.add("active");

});

sortClose?.addEventListener("click", () => {

    sortSheet.classList.remove("active");

});

sortSheet?.addEventListener("click", (e) => {

    if (e.target === sortSheet) {

        sortSheet.classList.remove("active");

    }

});

sortSheet?.querySelectorAll("[data-sort]").forEach(option => {

    option.addEventListener("click", () => {

        const url = new URL(window.location);

        if (option.dataset.sort) {

            url.searchParams.set("sort_by", option.dataset.sort);

        } else {

            url.searchParams.delete("sort_by");

        }

        window.location = url;

    });

});



function initBulkOrderPopup() {
    const popup = document.querySelector(".hgp-bulk-popup");
    if (!popup || popup.dataset.hgpReady) return;
    popup.dataset.hgpReady = "true";

    let opener = null;
    const dialog = popup.querySelector(".hgp-bulk-popup-box");
    const closePopup = () => {
        popup.classList.remove("is-open");
        popup.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hgp-modal-open");
        opener?.focus();
    };

    document.addEventListener("click", (event) => {
        const trigger = event.target.closest(".hgp-bulk-order-btn");
        if (!trigger) return;
        event.preventDefault();
        opener = trigger;
        popup.classList.add("is-open");
        popup.setAttribute("aria-hidden", "false");
        document.body.classList.add("hgp-modal-open");
        requestAnimationFrame(() => dialog?.focus());
    });

    popup.querySelectorAll("[data-hgp-bulk-close]").forEach((element) => element.addEventListener("click", closePopup));
    document.addEventListener("keydown", (event) => { if (event.key === "Escape" && popup.classList.contains("is-open")) closePopup(); });
}

function initCollectionVideoModal() {
    const modal = document.querySelector(".hgp-product-video-modal");
    if (!modal || modal.dataset.hgpReady) return;
    modal.dataset.hgpReady = "true";

    const content = modal.querySelector(".hgp-product-video-content");
    const closeButton = modal.querySelector(".hgp-product-video-close");
    let opener = null;
    const closeModal = () => {
        content?.querySelectorAll("video").forEach((video) => video.pause());
        modal.classList.remove("is-open");
        modal.setAttribute("aria-hidden", "true");
        document.body.classList.remove("hgp-modal-open");
        if (content) content.replaceChildren();
        opener?.focus();
    };

    // Capture phase means a card or theme script cannot swallow this click first.
    document.addEventListener("click", (event) => {
        const trigger = event.target.closest(".hgp-card-video-trigger");
        if (!trigger) return;
        const template = trigger.closest(".hgp-card")?.querySelector(".hgp-card-video-template");
        if (!template?.content || !content) return;

        event.preventDefault();
        event.stopPropagation();
        opener = trigger;
        content.replaceChildren(template.content.cloneNode(true));
        modal.classList.add("is-open");
        modal.setAttribute("aria-hidden", "false");
        document.body.classList.add("hgp-modal-open");
        closeButton?.focus();
        content.querySelector("video")?.play().catch(() => { });
    }, true);

    closeButton?.addEventListener("click", closeModal);
    modal.querySelector(".hgp-product-video-backdrop")?.addEventListener("click", closeModal);
    document.addEventListener("keydown", (event) => { if (event.key === "Escape" && modal.classList.contains("is-open")) closeModal(); });
}

document.addEventListener("click", async (e) => {
  const button = e.target.closest(".hgp-buy-now");

  if (!button) return;

  e.preventDefault();

  const variantId = Number(button.dataset.variant);

  if (!variantId) {
    console.error("Buy Now: Variant ID missing");
    return;
  }

  button.disabled = true;

  try {
    const response = await fetch("/cart/add.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json"
      },
      body: JSON.stringify({
        items: [
          {
            id: variantId,
            quantity: 1
          }
        ]
      })
    });

    if (!response.ok) {
      const errorText = await response.text();
      throw new Error(errorText);
    }

    // Existing cart is preserved.
    // Newly selected product is added to it.
    window.location.href = "/checkout";

  } catch (error) {
    console.error("Buy Now failed:", error);

    button.disabled = false;
  }
});

// Keep these independent from the other collection initializers.
if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initBulkOrderPopup, { once: true });
    document.addEventListener("DOMContentLoaded", initCollectionVideoModal, { once: true });
} else {
    initBulkOrderPopup();
    initCollectionVideoModal();
}


document.addEventListener("DOMContentLoaded", hideLoader);

window.addEventListener("load", hideLoader);

window.addEventListener("pageshow", hideLoader);

window.addEventListener("popstate", hideLoader);